(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualService', ReporteEvaluativoVirtualService);

    ReporteEvaluativoVirtualService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteVirtual:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportevirtual:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreportevirtual:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreportevirtual:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreportevirtual:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();